import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="flex flex-col md:flex-row justify-between gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center mb-4">
              <div className="h-8 w-8 rounded-lg flex items-center justify-center">
                <img src="images/logo.png" alt="royal econ" />
              </div>
              <span className="ml-2 text-xl font-bold">Royal Econ</span>
            </div>
            <ul className="space-y-1">
              <li className="text-gray-400 font-bold">HARSHA AMARAKOON</li>
              <li className="text-gray-400">
                B.Sc Mgt(Sp) University of Jayawardenapura
              </li>
              <li className="text-gray-400">
                Former Teacher at Nalanda College, Colombo 10
              </li>
              <li className="text-gray-400">
                Former Visiting Lecturer at St Joseph’s College. Colombo
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-1">
              <li className="text-gray-400">+94 71 222 7623</li>
              <li className="text-gray-400">+94 77 474 7623</li>
              <li className="text-gray-400">royaleconpvtltd@gmail.com</li>
              <li className="text-gray-400">RN: PV00321138</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-center items-center">
            <p className="text-gray-400 text-sm ">
              © 2026 Royal Econ. All rights reserved.
            </p>
            {/* <div className="flex space-x-6 mt-4 md:mt-0">
              <a
                href="#"
                className="text-gray-400 hover:text-white transition duration-300"
              >
                Privacy Policy
              </a>
              <a
                href="#"
                className="text-gray-400 hover:text-white transition duration-300"
              >
                Terms of Service
              </a>
            </div> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
